import { computed, reactive } from 'vue'

export const useLoadingController = () => {
    const loadingMap = reactive(new Map<string, boolean>())

    const addProcessApi = (url: string) => {
        loadingMap.set(url, true)
    }

    const deleteProcessApi = (url: string) => {
        loadingMap.delete(url)
    }

    const isLoading = computed(() => loadingMap.size > 0)

    return {
        addProcessApi,
        deleteProcessApi,
        isLoading,
    }
}

export const loadingController = useLoadingController()
